import {
  Box,
  Divider,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

import { useVerification } from "../../../../../context/Verification.context";
import ArtifactButton from "../../../../base/dialog-body/ArtifactButton.component";
import Theme from "../../../../../utils/Theme";
import { InputValidation } from "../../../../../utils/InputValidationRegex";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import AppButton from "../../../../base/AppButton.component";
import TextUnAvailable from "./TextUnAvailable";
import ReferralResponse from "./ReferralResponse";

const ReviewResponse = ({
  artifact,
  setReviewScreen,
  setRefferalScreen,
  isAIReview,
  onStepInteraction,
}) => {
  const verification = useVerification();

  const ReviewHandler = (questionId, answer) => {
    const hasReferralVideo = Boolean(
      artifact?.referral_ai_url?.english_url || artifact?.referral_ai_url?.spanish_url,
    );
    onStepInteraction?.(
      answer === "yes" && hasReferralVideo ? { hideOverlay: true } : undefined,
    );

    if (questionId) {
      const newReviewResponse = {
        user_id: parseInt(verification?.customer?.userId),
        review_question_id: questionId,
        answer: answer,
        created_by: parseInt(verification?.employeeId),
        updated_by: parseInt(verification?.employeeId),
      };
      if (answer === "yes") {
        verification.setArtifactsResponse((prevState) => ({
          ...prevState,
          reviewResponse: newReviewResponse,
          referralResponse: [
            {
              name: "",
              mobile_number: "",
            },
          ],
        }));
      } else {
        verification.setArtifactsResponse((prevState) => ({
          ...prevState,
          reviewResponse: newReviewResponse,
        }));
      }

      setReviewScreen(true);
    }
  };

  const handleTextChange = (index, field, value, questionId) => {
    onStepInteraction?.();
    verification.setArtifactsResponse((prevState) => ({
      ...prevState,
      referralResponse: (prevState?.referralResponse || []).map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
              user_id: parseInt(verification?.customer?.userId),
              review_question_id: questionId,
              created_by: parseInt(verification?.employeeId),
              updated_by: parseInt(verification?.employeeId),
            }
          : item
      ),
    }));
    setRefferalScreen(true);
  };

  const handleUser = () => {
    const newRefUsers = {
      name: "",
      mobile_number: "",
    };

    verification.setArtifactsResponse((prev) => ({
      ...prev,
      referralResponse: [...prev?.referralResponse, newRefUsers],
    }));
  };

  const hasMessage = verification.aiData.spanish
    ? !!artifact?.es_referral_question
    : !!artifact?.referral_question;

  const hasReviewMessage = verification.aiData.spanish
    ? !!artifact?.es_review_question
    : !!artifact?.review_question;

  const ReferralButton = () => {
    return (
      <Box
        sx={{
          display: "flex",
          width: "90%", // Changed from 90% to 100%
          justifyContent: "center",
          alignItems: "center",
          mt: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "90%", // Changed from 90% to 100%
            justifyContent: "center",
            alignItems: "center",
            gap: 1, // Reduced from gap: 1
          }}
        >
          {verification.artifactsResponse?.referralResponse?.map(
            (item, index) => (
              <Box
                // key={index}
                sx={{
                  display: "flex",
                  width: "100%",
                  border: "1px solid #D0D5DD",
                  borderRadius: "6px", // Reduced from 8px
                  padding: "12px", // Reduced from 12px
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: {
                    xs: "column", // <600
                    sm: "column", // 600–750
                    md: "row", // 750–1024
                    lg: "row", // 1024–1440
                  },

                  gap: {
                    xs: "8px", // <600
                    sm: "8px", // 600–750
                    md: "16px", // 750–1024
                    lg: "16px", // >1024
                  },

                  backgroundColor: isAIReview ? "white" : "transparent",
                  position: "relative", // Added for mobile button positioning
                }}
              >
                {/* NAME FIELD */}
                <FormControl
                  fullWidth
                  // error={InputValidation.nameValidation(item.name)}
                  sx={{ mb: -1 }} // Reduce bottom margin
                >
                  <TextField
                    label={verification.aiData.spanish ? "Nombre" : "Name"}
                    fullWidth
                    value={item.name}
                    size="small" // Added small size to reduce height
                    onChange={(e) =>
                      handleTextChange(
                        index,
                        "name",
                        e.target.value,
                        artifact?.id
                      )
                    }
                    error={InputValidation.nameValidation(item.name)}
                    sx={{
                      mt: 0.25,
                      mb: 0,
                      "& label": {
                        color: InputValidation.nameValidation(item.name)
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: InputValidation.nameValidation(item.name)
                            ? Theme.palette.error.main
                            : Theme.palette.primary.main,
                          // borderWidth: "2px",
                        },
                        "&:hover fieldset": {
                          borderColor: InputValidation.nameValidation(item.name)
                            ? Theme.palette.error.main
                            : Theme.palette.primary.main,
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: InputValidation.nameValidation(item.name)
                            ? Theme.palette.error.main
                            : Theme.palette.primary.main,
                          // borderWidth: "2px",
                        },
                      },
                    }}
                  />
                  <FormHelperText
                    sx={{ color: Theme.palette.error.main, fontSize: "10px" }}
                  >
                    {InputValidation.nameValidation(item.name)
                      ? verification.aiData.spanish
                        ? "Por favor, introduzca un nombre válido?"
                        : "Please enter a valid name"
                      : " "}
                  </FormHelperText>
                </FormControl>

                {/* MOBILE NUMBER FIELD */}
                <FormControl
                  fullWidth
                  // error={InputValidation.numberValidation(item.mobile_number)}
                  sx={{
                    mb: -1,
                    width: {
                      xs: index === 0 ? "78%" : "100%", // <600
                      sm: index === 0 ? "78%" : "100%", // 600–750
                      md: "100%", // 750–1024
                      lg: "100%", // >1024
                    },

                    alignSelf: "flex-start",
                  }}
                >
                  <TextField
                    label={
                      verification.aiData.spanish
                        ? "Número de teléfono móvil"
                        : "Mobile Number"
                    }
                    fullWidth
                    value={InputValidation.phoneNumberFormat(
                      item.mobile_number || ""
                    )}
                    size="small" // Added small size to reduce height
                    onChange={(e) =>
                      handleTextChange(
                        index,
                        "mobile_number",
                        e.target.value,
                        artifact?.id
                      )
                    }
                    error={InputValidation.numberValidation(
                      item.mobile_number || ""
                    )}
                    sx={{
                      mt: 0.25,
                      mb: 0,
                      "& label": {
                        color: InputValidation.nameValidation(item.name)
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },

                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: InputValidation.nameValidation(
                            item.mobile_number
                          )
                            ? Theme.palette.error.main
                            : Theme.palette.primary.main,
                          // borderWidth: "2px",
                        },
                        "&:hover fieldset": {
                          borderColor: InputValidation.nameValidation(
                            item.mobile_number
                          )
                            ? Theme.palette.error.main
                            : Theme.palette.primary.main,
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: InputValidation.nameValidation(
                            item.mobile_number
                          )
                            ? Theme.palette.error.main
                            : Theme.palette.primary.main,
                          // borderWidth: "2px",
                        },
                      },
                    }}
                  />

                  <FormHelperText
                    sx={{
                      color: Theme.palette.error.main,
                      fontSize: "10px",
                    }}
                  >
                    {InputValidation.numberValidation(item.mobile_number)
                      ? verification.aiData.spanish
                        ? "Por favor, introduzca un número válido"
                        : "Please enter a valid number"
                      : " "}
                  </FormHelperText>
                </FormControl>

                {/* Add New Button below Mobile Number field on mobile */}
                {window.innerWidth <= 750 && index === 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      ml: 24,
                      // Add some top margin
                    }}
                  >
                    {/* <Divider orientation="vertical" flexItem /> */}
                    <AppButton
                      variant={"text"}
                      buttonText={"Add New"}
                      size={"medium"}
                      sx={{
                        textDecoration: "underline",
                        padding: 0,
                        minWidth: "auto",
                        fontSize: "0.65rem",
                        mt: -6,
                        ml: 3,
                      }}
                      clickHandler={() => handleUser()}
                    />
                  </Box>
                )}

                {/* Divider and Add New Button - ONLY FOR FIRST ITEM ON DESKTOP */}
                {index === 0 && window.innerWidth > 750 && (
                  <>
                    <Divider orientation="vertical" flexItem />

                    {/* ADD NEW */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        cursor: "pointer",
                        gap: 0.5, // Reduced from 0.5
                        whiteSpace: "nowrap",
                        ml: "auto",
                        mt: -1, // Adjusted negative margin
                      }}
                    >
                      <AppButton
                        variant={"text"}
                        buttonText={"Add New"}
                        size={"medium"} // Changed from medium to small
                        sx={{
                          textDecoration: "underline",
                          padding: 0,
                          minWidth: "auto",
                          fontSize: "0.75rem", // Smaller font size
                        }}
                        clickHandler={() => handleUser()}
                      />
                    </Box>
                  </>
                )}
              </Box>
            )
          )}
        </Box>
      </Box>
    );
  };

  // ------------------- REVIEW BUTTON -------------------
  const ReviewButton = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column", // mobile
            sm: "column", // ≤600
            md: "row", // ≥900
          },
          gap: {
            xs: 3, // <600
            sm: 3, // 600–750
            md: 1, // 750–1024
            lg: 1, // 1024–1440
          },

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ArtifactButton
          text={!verification.aiData.spanish ? "Yes" : "Sí"}
          variant={
            verification.artifactsResponse?.reviewResponse?.answer === "yes"
              ? "contained"
              : "outlined"
          }
          onClick={() => {
            ReviewHandler(artifact.id, "yes");
          }}
          sx={{
            bgcolor:
              verification.artifactsResponse?.reviewResponse?.answer === "yes"
                ? null
                : isAIReview
                ? "white"
                : "transparent",
          }}
        />

        <ArtifactButton
          text={"No"}
          variant={
            verification.artifactsResponse?.reviewResponse?.answer === "no"
              ? "contained"
              : "outlined"
          }
          onClick={() => {
            ReviewHandler(artifact.id, "no");
          }}
          sx={{
            bgcolor:
              verification.artifactsResponse?.reviewResponse?.answer === "no"
                ? null
                : isAIReview
                ? "white"
                : "transparent",
          }}
        />
      </Box>
    );
  };

  // ------------------- MAIN RETURN UI -------------------
  return (
    <Box
      // display={"flex"}
      width={"100%"}
      // justifyContent={"center"}
      // alignItems={"center"}
    >
      {verification.artifactsResponse?.reviewResponse?.answer === "yes" ? (
        <>
          {!isAIReview && (
            <TextUnAvailable
              text={artifact?.referral_question}
              es_text={artifact?.es_referral_question}
            />
          )}
          {hasMessage && (
            <Box
              sx={{
                display: "flex",
                gap: 5,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {" "}
              <ReferralResponse
                artifact={artifact}
                handleTextChange={handleTextChange}
                handleUser={handleUser}
                isAIReview={isAIReview}
                
                
              />
            </Box>
          )}
        </>
      ) : (
        <>
          {isAIReview ? (
            <>{hasReviewMessage && <ReviewButton />}</>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: 5,
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextUnAvailable
                  text={artifact?.review_question}
                  es_text={artifact?.es_review_question}
                />

                {hasReviewMessage && <ReviewButton />}
              </Box>
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default ReviewResponse;
